var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-list',_vm._l((_vm.stamps),function(stamp,index){return _c('ion-item',{key:index,on:{"click":function($event){$event.preventDefault();return _vm.chooseStamp(stamp)}}},[_c('div',{class:{ 'active': _vm.current === stamp.id },domProps:{"innerHTML":_vm._s(stamp.label)}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }